<template>
  <div>
    <b-row>
      <!-- ความเร็วเฉลี่ย -->
      <b-col
        lg="6"
        md="6"
        xs="6"
      >
        <b-col>
          <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
            <svg
              width="102%"
              height="100%"
              viewBox="0 0 748 422"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <!-- <path
                d="M689.382 420.369H689.383H747.5V393.716V366.563V214.394V62.2252V27.5371L723.483 0.5H0.5V27.1528V54.3056V364.3V394.437L24.5167 421.5L689.382 420.369Z"
                stroke="#00B058"
              />
              <path
                d="M55 420H25.1183L2 397V371"
                stroke="#00B058"
                stroke-width="4"
              />
              <path
                d="M693 2H722.882L746 25V51"
                stroke="#00B058"
                stroke-width="4"
              /> -->
              <foreignObject
                width="100%"
                height="100%"
                x="25"
                y="17"
              >
                <div>
                  <b-img
                    src="@/assets/images/icons/markeranalytic120\iconA120\analytic120speed.svg"
                  />
                </div>
              </foreignObject>
              <foreignObject
                width="100%"
                height="100%"
                y="20"
                x="-30"
              >
                <span style="color:#ffffff;font-size:20px; margin-left:100px">ความเร็วเฉลี่ย</span>
              </foreignObject>
              <foreignObject
                width="100%"
                height="100%"
                y="80"
                x="0"
              >
                <VueSvgGauge
                  :start-angle="-90"
                  :end-angle="90"
                  :value="AVGSpeed"
                  :separator-step="7"
                  :inner-radius="74"
                  :min="0"
                  :max="200"
                  :gauge-color="[{ offset: 0, color: '#FFA82B'}, { offset: 90, color: '#FF0000'}]"
                  :scale-interval="0.9"
                  style="height: 210px; margin-top: 20px;"
                  needleshape
                  :decimals="2"
                >
                  <div
                    v-if="AVGSpeed < 120"
                    align="center"
                    class="inner-text"
                  >
                    <span><b style="color: #FFD443;"> {{ AVGSpeed }} </b>กม/ชม.</span>
                  </div>
                  <div
                    v-else
                    align="center"
                    class="inner-text"
                  >
                    <span><b style="color: #FF0000;"> {{ AVGSpeed }} </b>กม/ชม.</span>
                  </div>
                </VueSvgGauge>
                <div
                  class="inner-text2"
                >
                  <span>0</span>
                  <span class="inner-text3">200</span>
                </div>

              </foreignObject>
            </svg>
          </b-card>
        </b-col>
      <!-- รถขับเลนขวา -->
      </b-col>
      <b-col
        lg="6"
        md="6"
        xs="6"
      >
        <b-col>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 739 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.5 175.296L24.2101 199.5H680.168H738.5V187.632V175.222V103.247V36.7321V24.2071L714.793 0.5H0.5V12.9032V25.8065V175.296Z"
              stroke="#00B058"
            />
            <path
              d="M54 198H24.6821L2 175V149"
              stroke="#00B058"
              stroke-width="4"
            />
            <path
              d="M685 2H714.318L737 25V51"
              stroke="#00B058"
              stroke-width="4"
            />
            <foreignObject
              width="100%"
              height="100%"
              x="25"
              y="17"
            >
              <div>
                <b-img
                  src="@/assets/images/icons/markeranalytic120\iconA120\a90.svg"
                />
              </div>
            </foreignObject>
            <foreignObject
              width="100%"
              height="100%"
              x="60"
              y="20"
            >
              <span style="color:#ffffff;font-size:20px; font-weight: 600; margin-left:10px">รถขับต่ำกว่า 90 km/hr เลนขวา</span>
            </foreignObject>
            <foreignObject
              x="20"
              y="80"
              width="100%"
              height="100%"
              color="#ffffff"
            >
              <span style="text-align:left; font-weight: 700; font-size:40px">
                {{ Speed90 }}
              </span>
              <span
                style="text-align:center; font-weight: 600; font-size:20px"
              >
                คัน
              </span>
            </foreignObject>
            <foreignObject
              x="560"
              y="80"
              width="300"
              height="150"
              color="#ffffff"
            >
              <b-card-header>
                <b-button
                  id="toggle-btn"
                  v-b-modal="'modalRightLane90'"
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  style="font-size: 16px;"
                  title="Click to show more"
                >
                  <span
                    class="align-middle"
                    style="color: #11DF00;"
                  >
                    ดูเพิ่มเติม
                    <feather-icon
                      icon="ChevronsRightIcon"
                      size="16"
                    />
                  </span>
                </b-button>
              </b-card-header>
            </foreignObject>
          </svg>
        </b-col>
        <br>
        <b-col>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 739 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.5 175.296L24.2101 199.5H680.168H738.5V187.632V175.222V103.247V36.7321V24.2071L714.793 0.5H0.5V12.9032V25.8065V175.296Z"
              stroke="#00B058"
            />
            <path
              d="M54 198H24.6821L2 175V149"
              stroke="#00B058"
              stroke-width="4"
            />
            <path
              d="M685 2H714.318L737 25V51"
              stroke="#00B058"
              stroke-width="4"
            />
            <foreignObject
              width="100%"
              height="100%"
              x="25"
              y="17"
            >
              <div>
                <b-img
                  src="@/assets/images/icons/markeranalytic120\iconA120\a120.svg"
                />
              </div>
            </foreignObject>
            <foreignObject
              width="100%"
              height="100%"
              x="60"
              y="20"
            >
              <span style="color:#ffffff;font-size:20px; font-weight: 600; margin-left:10px">รถขับมากกว่า 120 km/hr เลนขวา</span>
            </foreignObject>
            <foreignObject
              x="20"
              y="80"
              width="100%"
              height="100%"
              color="#ffffff"
            >
              <span style="text-align:left; font-weight: 600; font-size:40px">
                {{ Speed120 }}
              </span>
              <span
                style="text-align:center; font-weight: 600; font-size:20px"
              >
                คัน
              </span>
            </foreignObject>
            <foreignObject
              x="560"
              y="80"
              width="300"
              height="150"
              color="#ffffff"
            >
              <b-card-header>
                <b-button
                  id="toggle-btn"
                  v-b-modal="'modalRightLane120'"
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  style="font-size: 16px;"
                  title="Click to show more"
                >
                  <span
                    class="align-middle"
                    style="color: #11DF00;"
                  >
                    ดูเพิ่มเติม
                    <feather-icon
                      icon="ChevronsRightIcon"
                      size="16"
                    />
                  </span>
                </b-button>
              </b-card-header>
            </foreignObject>
          </svg>
        </b-col>
      </b-col>
    </b-row>
    <br>

    <!----------- ส่วนที่ 2 ------------------------------ AnalyticDonughnutAI --------------------------------------->
    <b-row>
      <!-- สัดส่วนเหตุการณ์ต่างๆ -->
      <b-col
        lg="6"
        md="6"
        xs="6"
      >
        <b-col>
          <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 500px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
            <div>
              <span style="font-size:20px; color: #fff;">สัดส่วนเหตุการณ์ต่างๆ</span>
            </div>

            <div class="pie-text text-center">
              <h3 class="font-weight-bold">
                โดยรวม
              </h3>
              <h2 class="font-weight-bolder">
                {{ Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
              </h2>
            </div>
            <div class="chart">
              <app-echart-doughnut
                :series="series"
              />
            </div>
          </b-card>

        </b-col>
      </b-col>

      <!-- รถจอด / อุบัติเหตุ -->
      <b-col
        lg="6"
        md="6"
        xs="6"
      >
        <b-col>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 739 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.5 175.296L24.2101 199.5H680.168H738.5V187.632V175.222V103.247V36.7321V24.2071L714.793 0.5H0.5V12.9032V25.8065V175.296Z"
              stroke="#00B058"
            />
            <path
              d="M54 198H24.6821L2 175V149"
              stroke="#00B058"
              stroke-width="4"
            />
            <path
              d="M685 2H714.318L737 25V51"
              stroke="#00B058"
              stroke-width="4"
            />
            <foreignObject
              width="100%"
              height="100%"
              x="25"
              y="17"
            >
              <div>
                <b-img
                  src="@/assets/images/icons/markeranalytic120\iconA120\accident.svg"
                />
              </div>
            </foreignObject>
            <foreignObject
              width="100%"
              height="100%"
              x="60"
              y="20"
            >
              <span style="color:#ffffff;font-size:20px; font-weight: 600; margin-left:10px">รถจอด / อุบัติเหตุ</span>
            </foreignObject>
            <foreignObject
              x="20"
              y="80"
              width="100%"
              height="100%"
              color="#ffffff"
            >
              <span style="text-align:left; font-weight: 700; font-size:40px">
                {{ CarStop }}
              </span>
              <span
                style="text-align:center; font-weight: 600; font-size:20px"
              >
                คัน
              </span>
            </foreignObject>
            <foreignObject
              x="560"
              y="80"
              width="300"
              height="150"
              color="#ffffff"
            >
              <b-card-header>
                <b-button
                  id="toggle-btn"
                  v-b-modal="'modalCarStop'"
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  style="font-size: 16px;"
                  title="Click to show more"
                >
                  <span
                    class="align-middle"
                    style="color: #11DF00;"
                  >
                    ดูเพิ่มเติม
                    <feather-icon
                      icon="ChevronsRightIcon"
                      size="16"
                    />
                  </span>
                </b-button>
              </b-card-header>
            </foreignObject>
          </svg>
        </b-col>
        <br>
        <b-col>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 739 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.5 175.296L24.2101 199.5H680.168H738.5V187.632V175.222V103.247V36.7321V24.2071L714.793 0.5H0.5V12.9032V25.8065V175.296Z"
              stroke="#00B058"
            />
            <path
              d="M54 198H24.6821L2 175V149"
              stroke="#00B058"
              stroke-width="4"
            />
            <path
              d="M685 2H714.318L737 25V51"
              stroke="#00B058"
              stroke-width="4"
            />
            <foreignObject
              width="100%"
              height="100%"
              x="25"
              y="17"
            >
              <div>
                <b-img
                  src="@/assets/images/icons/markeranalytic120\iconA120\reverse.svg"
                />
              </div>
            </foreignObject>
            <foreignObject
              width="100%"
              height="100%"
              x="60"
              y="20"
            >
              <span style="color:#ffffff;font-size:20px; font-weight: 600; margin-left:10px">รถย้อนศร</span>
            </foreignObject>
            <foreignObject
              x="20"
              y="80"
              width="100%"
              height="100%"
              color="#ffffff"
            >
              <span style="text-align:left; font-weight: 600; font-size:40px">
                {{ WrongWay }}
              </span>
              <span
                style="text-align:center; font-weight: 600; font-size:20px"
              >
                คัน
              </span>
            </foreignObject>
            <foreignObject
              x="560"
              y="80"
              width="300"
              height="150"
              color="#ffffff"
            >
              <b-card-header>
                <b-button
                  id="toggle-btn"
                  v-b-modal="'modalWrongWay'"
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  style="font-size: 16px;"
                  title="Click to show more"
                >
                  <span
                    class="align-middle"
                    style="color: #11DF00;"
                  >
                    ดูเพิ่มเติม
                    <feather-icon
                      icon="ChevronsRightIcon"
                      size="16"
                    />
                  </span>
                </b-button>
              </b-card-header>
            </foreignObject>
          </svg>
        </b-col>
      </b-col>
    </b-row>
    <ModalCarStop />
    <ModalRightLane90 />
    <ModalRightLane120 />
    <ModalWrongWay />
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BButton, BCardHeader, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import { VueSvgGauge } from 'vue-svg-gauge'
import Ripple from 'vue-ripple-directive'
import AppEchartDoughnut from './AppEchartDoughnut.vue'
import ModalCarStop from '@/views/analytic120/modalAnalytic/ModalCarStop.vue'
import ModalRightLane90 from '@/views/analytic120/modalAnalytic/ModalRightLane90.vue'
import ModalRightLane120 from '@/views/analytic120/modalAnalytic/ModalRightLane120.vue'
import ModalWrongWay from '@/views/analytic120/modalAnalytic/ModalWrongWay.vue'
// import AppEchartGauge120 from './AppEchartGauge120.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BButton,
    BCardHeader,
    BCard,
    AppEchartDoughnut,
    VueSvgGauge,
    ModalCarStop,
    ModalRightLane90,
    ModalRightLane120,
    ModalWrongWay,
    // AppEchartGauge120,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      AVGSpeed: 0,
      Speed90: 0,
      Speed120: 0,

      CarStop: 0,
      WrongWay: 0,
      Total: 0,
      series: [
        {
          color: ['#FFD22B', '#FF812C', '#00FFAB', '#579BFE'],
          name: 'เหตุการณ์',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: true,
          label: {
            show: true,
            fontSize: '14',
            formatter: ' {b}: {c} ',
          },
          labelLine: {
            show: true,
          },
          data: [
            {
              value: '', name: 'รถจอด/อุบัติเหตุ', iconColor: '#FFD22B', percent: '',
            },
            {
              value: '', name: 'รถย้อนศร', iconColor: '#FF812C', percent: '',
            },
            {
              value: '', name: 'รถบรรทุกเลนขวา', iconColor: '#00FFAB', percent: '',
            },
            {
              value: '', name: 'รถขับเร็ว/ช้าเลนขวา', iconColor: '#579BFE', percent: '',
            },
          ],
        },
      ],

      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.interval = setInterval(() => {
      this.getTotalAI()
      this.getPieData()
      this.getAVGSpeed()
    }, 300000)
  },
  mounted() {
    this.getTotalAI()
    this.getPieData()
    this.getAVGSpeed()
  },
  methods: {
    getTotalAI() {
      axios
        .post('/getSumCountTotal', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username })
        .then(response => {
          this.Speed90 = response.data[1][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.Speed120 = response.data[2][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

          this.CarStop = response.data[0][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.WrongWay = response.data[5][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        })
        .catch(error => {
          console.log(error)
        })
    },

    getPieData() {
      axios
        .post('/getSumCountTotal', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.series[0].data[0].value = response.data[0][0].Total
          this.series[0].data[1].value = response.data[5][0].Total
          this.series[0].data[2].value = response.data[4][0].Total
          this.series[0].data[3].value = response.data[1][0].Total + response.data[2][0].Total + response.data[3][0].Total
          this.Total = response.data[0][0].Total + response.data[5][0].Total + response.data[4][0].Total
          + (response.data[1][0].Total + response.data[2][0].Total + response.data[3][0].Total)

          this.series[0].data[0].percent = parseFloat((response.data[0][0].Total / this.Total) * 100).toFixed(2)
          this.series[0].data[1].percent = parseFloat((response.data[5][0].Total / this.Total) * 100).toFixed(2)
          this.series[0].data[2].percent = parseFloat((response.data[4][0].Total / this.Total) * 100).toFixed(2)
          this.series[0].data[3].percent = parseFloat(((response.data[1][0].Total + response.data[2][0].Total + response.data[3][0].Total) / this.Total) * 100).toFixed(2)
          if (response.data[0].Total === 0 && response.data[1].Total === 0 && response.data[2].Total === 0
           && response.data[3].Total === 0 && response.data[4].Total === 0 && response.data[5].Total === 0) {
            this.series[0].data[0].percent = 0
            this.series[0].data[1].percent = 0
            this.series[0].data[2].percent = 0
            this.series[0].data[3].percent = 0
          }
          // eslint-disable-next-line prefer-destructuring
        })
        .catch(error => {
          console.log(error)
        })
    },

    getAVGSpeed() {
      axios
        .post('/getStaticTotalAI', { department: this.userData.department })
        .then(response => {
          this.AVGSpeed = response.data[0].countNum
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.pie-text{
      width: 200px;
      position:absolute;
      margin: auto;
      left: 0;
      right: 0;
      top: 40%;
      bottom: 0;
    }

    .inner-text {

  display: flex;
  justify-content: center;
  margin-top: 75px;
  font-size: 20px;
  color: #FFFFFF;
  font-weight: bold;
}
.inner-text2 {
margin-left: 220px;
font-size: 44px;
color: #FFB54B;
font-weight: bold;
}
.inner-text3 {
margin-left: 270px;
font-size: 44px;
color: #FFB54B;
font-weight: bold;
}

.br {
      display: block;
      margin-bottom: 0em;
    }
  </style>
